import React from "react";
import {
  Box,
  VStack,
  HStack,
  Badge,
  Text,
  Button,
  useColorModeValue,
  Stack,
  Card,
  CardBody,
  Select
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ShareButton } from '../utils/share';
import SocialShare from "../components/SocialShare";

const ListingCard = ({ listing, onOpenDetails }) => {
  const { t } = useTranslation();
  const cardBgColor = useColorModeValue("white", "gray.700");
  const textColor = useColorModeValue("brand.400", "white");
  const accentColor = useColorModeValue("brand.300", "blue.300");

  const calculateEquivalent = () => {
    if (listing.offeredAmount && listing.rate) {
      const equivalent = `${(parseFloat(listing.offeredAmount) * parseFloat(listing.rate)).toLocaleString()} ${listing.desiredCurrency || "XAF"}`;
      return `${equivalent}`;
    }
    return t("listingcard.na_placeholder");
  };

  const handleViewDetails = () => {
    onOpenDetails(listing);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: listing.id * 0.2 }}
    >
      <Card
        bg={cardBgColor}
        p={2}
        borderRadius="lg"
        shadow="lg"
        transition="transform 0.3s"
        _hover={{ transform: "scale(1.05)", shadow: "2xl" }}
        h="100%"
      >
        <CardBody display="flex" flexDirection="column" h="100%">
          <VStack spacing={2} align="stretch" flexGrow={1}>
            <HStack justifyContent="space-between">
              <Badge colorScheme="blue">{listing.location.town || t("listingcard.unknown_location")}</Badge>
              
            </HStack>

            {/* Trade Information */}
            <Stack spacing={1}>
              <Text fontWeight="bold" fontSize="lg" color={textColor}>
                {/* {listing.amount || } {listing.offeredCurrency || "CAD"} {t("listingcard.at_label")}{" "} */}
                {listing.rate || t("listingcard.na_placeholder")} {" "}
                {listing.exchangeRatePair || t("listingcard.currency_placeholder")}
              </Text>
              <Text fontSize="md" color="brand.500">
                {Array.isArray(listing.paymentMethods) ? listing.paymentMethods.join(", ") : listing.paymentMethods || t("listingcard.na_placeholder")}
              </Text>
              <Text fontWeight="bold" color="brand.400">
                {t("listingcard.estimated_label")}: {calculateEquivalent()}
              </Text>
              <Text fontWeight="light" fontSize="xs" color="brand.400">
                {t("listingcard.created_at_label")}:{" "}
                {listing.createdAt ? new Date(listing.createdAt.seconds * 1000).toLocaleString() : t("listingcard.na_placeholder")}
              </Text>
            </Stack>
          </VStack>

          {/* Call to Action Button */}
          <VStack
            spacing={2}
            gap={2}
            align="end"
            mb="-20px"
            mt={{ base: 6, md: 0 }}
            position={{ base: "static", md: "absolute" }}
            bottom={{ base: "unset", md: 9 }}
            right={{ base: "unset", md: 9 }}
          >
            {listing.status === "active" ? (
                <Badge colorScheme="green" mb={3}>{t("listingcard.available_status")}</Badge>
              ) : listing.status === "matched" ? (
                <Badge colorScheme="orange" mb={3}>{t("listingcard.under_negotiation_status")}</Badge>
              ) : (
                <Badge colorScheme="gray" mb={3}>{t("listingcard.unknown_status")}</Badge>
              )}

            <Button
              size="md"
              bg={accentColor}
              color="white"
              _hover={{ bg: "brand.400", transform: "scale(1.05)" }}
              transition="0.3s"
              onClick={handleViewDetails}
            >
              {t("listingcard.view_details_button")}
            </Button>
            {/* <ShareButton listingId={listing.id} /> */}
            <SocialShare
                url={`https://peerx.ca/personal/listings?listing=${listing.id}`}
                title={`Currently Available on PeerX: ${listing.rate} ${listing.exchangeRatePair}`}
                quote={`Looking to send or receive money? Check out this listing in ${listing.location.town}!`}
                hashtag="#PeerX, #Money, #Transfer, #Exchange, #Currency, #Remittance, #Trade"
              />
          </VStack>
        </CardBody>
      </Card>
    </motion.div>
  );
};

export default ListingCard;
